module.exports = __webpack_public_path__ + "img/gold_coin.dd601d46.png";